import React from 'react';
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';
import { MODALS } from '../../../../../config/images';

const UploadDocument = ({
  showModalUploadDocument,
  closeModal,
  openModal,
  acceptFiles,
  fieldMapping,
  onFileProcessed,
  strictMapping = true,
  text = "Sube tu documento aquí",
  proccessFile = true,
  multiple = false,
}) => {
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    e.target.value = "";

    if (!proccessFile) {
      onFileProcessed?.(multiple ? files : files[0]);
      closeModal();
      return;
    }

    const file = files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      let processedData;

      if (strictMapping) {
        // Procesar los datos según el fieldMapping
        processedData = jsonData.map(row => {
          const processedItem = {};
          Object.keys(fieldMapping).forEach(key => {
            processedItem[key] = row[fieldMapping[key]] || '';
          });
          return processedItem;
        });

      } else {
        processedData = jsonData.map((row, index) => {
          return {
            "#": index + 1,
            ...row
          };
        });
      }


      // Ejecutar callback con los datos procesados
      onFileProcessed(processedData, file);
      closeModal();
    };
    reader.readAsArrayBuffer(file);
  };

  if (!showModalUploadDocument) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[25%] w-[85%] h-auto bg-white border-dashed border border-[#666666] rounded-2xl shadow-lg flex flex-col pb-4  ">
        <div className='flex justify-end'>
          <button
            onClick={closeModal}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div
          onClick={openModal}
          className='flex flex-col items-center justify-center gap-6 px-8 pb-4'>
          <input
            type="file"
            id="file-upload"
            accept={acceptFiles}
            multiple={multiple}
            className="hidden"
            onChange={handleFileUpload}
          />
          <label htmlFor="file-upload" className="flex flex-col items-center gap-4 cursor-pointer">
            <svg width="42" height="44" viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 6.375C10 4.7174 10.6585 3.12769 11.8306 1.95558C13.0027 0.78348 14.5924 0.125 16.25 0.125H27.4563C28.699 0.126094 29.8905 0.620672 30.7687 1.5L39.8781 10.6063C40.7563 11.485 41.2497 12.6764 41.25 13.9187V37.625C41.25 39.2826 40.5915 40.8723 39.4194 42.0444C38.2473 43.2165 36.6576 43.875 35 43.875H24.5719C25.8318 42.9893 26.967 41.9382 27.9469 40.75H35C35.8288 40.75 36.6237 40.4208 37.2097 39.8347C37.7958 39.2487 38.125 38.4538 38.125 37.625V15.75H30.3125C29.0693 15.75 27.877 15.2561 26.9979 14.3771C26.1189 13.498 25.625 12.3057 25.625 11.0625V3.25H16.25C15.4212 3.25 14.6263 3.57924 14.0403 4.16529C13.4542 4.75134 13.125 5.5462 13.125 6.375V12.6937C12.0677 12.7895 11.0216 12.9831 10 13.2719V6.375ZM30.3125 12.625H37.4781L28.75 3.89688V11.0625C28.75 11.4769 28.9146 11.8743 29.2076 12.1674C29.5007 12.4604 29.8981 12.625 30.3125 12.625ZM14.6875 43.875C16.5342 43.875 18.3628 43.5113 20.069 42.8046C21.7751 42.0979 23.3254 41.062 24.6312 39.7562C25.937 38.4504 26.9729 36.9001 27.6796 35.194C28.3863 33.4878 28.75 31.6592 28.75 29.8125C28.75 27.9658 28.3863 26.1372 27.6796 24.431C26.9729 22.7249 25.937 21.1746 24.6312 19.8688C23.3254 18.563 21.7751 17.5272 20.069 16.8204C18.3628 16.1137 16.5342 15.75 14.6875 15.75C10.9579 15.75 7.38104 17.2316 4.74381 19.8688C2.10658 22.506 0.625 26.0829 0.625 29.8125C0.625 33.5421 2.10658 37.119 4.74381 39.7562C7.38104 42.3934 10.9579 43.875 14.6875 43.875ZM22.0438 28.7062C22.3371 28.9996 22.502 29.3976 22.502 29.8125C22.502 30.2274 22.3371 30.6254 22.0438 30.9188C21.7504 31.2121 21.3524 31.377 20.9375 31.377C20.5226 31.377 20.1246 31.2121 19.8312 30.9188L16.25 27.3344V36.0625C16.25 36.4769 16.0854 36.8743 15.7924 37.1674C15.4993 37.4604 15.1019 37.625 14.6875 37.625C14.2731 37.625 13.8757 37.4604 13.5826 37.1674C13.2896 36.8743 13.125 36.4769 13.125 36.0625V27.3344L9.54375 30.9188C9.25035 31.2121 8.85242 31.377 8.4375 31.377C8.02258 31.377 7.62465 31.2121 7.33125 30.9188C7.03785 30.6254 6.87303 30.2274 6.87303 29.8125C6.87303 29.3976 7.03785 28.9996 7.33125 28.7062L13.5812 22.4562C13.8725 22.1657 14.2667 22.0017 14.6781 22H14.6969C15.1042 22.0025 15.4944 22.164 15.7844 22.45L15.7938 22.4594L22.0438 28.7062Z" fill="#007696" />
            </svg>
            <p className="text-[16px] font-itcbook text-gray">
              {text}
            </p>
          </label>
        </div>
      </div>
    </div>
  );
};


UploadDocument.propTypes = {
  showModalUploadDocument: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  acceptFiles: PropTypes.string,
  fieldMapping: PropTypes.object.isRequired,
  onFileProcessed: PropTypes.func.isRequired,
  strictMapping: PropTypes.bool,
  multiple: PropTypes.bool,
};

UploadDocument.defaultProps = {
  acceptFiles: ".xlsx, .xls",
  strictMapping: true,
  multiple: false,
};

export default UploadDocument;
